const getQuery = (url) => {
	const href = url ? url : location.href;
	// 获取query数据字符串，因为有回调，中间可能会有ticket，所以取最后一个
	const queryStr = href.indexOf('?') !== -1 ? href.split('?')[href.split('?').length - 1] : null;
	if (queryStr) {
		// 到这里必定有query数据，所以进行拆分，根据&符号将各数据转化为数组，循环提取将
		let obj = {};
		queryStr.split('&').map((e) => {
			// 数字类型可以展示转化为数字类型
			obj[e.split('=')[0]] = isNaN(Number(e.split('=')[1]))
				? decodeURI(e.split('=')[1])
				: Number(e.split('=')[1]);
		});
		return obj;
	} else {
		return false;
	}
};

export default getQuery;
